import { deepFreeze } from '@/utils/objUtil'

export {
  LEVEL_ONE_APPEAL,
  APPEAL_SUB_STATUS,
  MATCH_STATUS,
  appealStatusMap,
  appealTrackStatusMap,
  appealSubStatusMap,
  levelOneAppealMap,
  levelTwoAppealMap,
  appealTypeMap,
  mediaTypeMap,
  appealPlatMap,
  rightFileExtType,
  fileExtType
} from '../../../const'

export const detailTabConfigList = deepFreeze([
  {
    label: '申诉歌曲信息',
    value: 'trackList',
  },
  {
    label: '待确认申诉信息',
    value: 'confirmList',
    ifShow: (state) => {
      return state.isLegal || state.isBussiness || state.isCompany
    }
  },
  {
    label: '申诉流转历史记录',
    value: 'history',
  },
  {
    label: '曲库匹配歌曲信息',
    value: 'match',
    ifShow: (state) => state.isAdmin || state.isEditor
  },
  {
    label: '申诉歌曲表现及各平台处置状态',
    value: 'deal',
    disabled: true,
  },
])

export const historyTabConfigList = deepFreeze([
  {
    label: '工单流水记录',
    value: 1,
  },
  {
    label: '歌单流水记录',
    value: 2,
  },
  // {
  //   label: '匹配歌曲流水记录',
  //   value: 3,
  // },
  {
    label: '申诉子单流水记录',
    value: 4,
  }
])

export function formatSubOrderDetail(detail) {
  const complaintTrackList = detail.complaintTrackList
  const complaintAppeal = detail.complaintAppeal
  return {
    ...detail,
    authorizer: detail.companyList.map(s => s.companyName).join('、'),
    // 父单字段打平
    appealOrder: complaintAppeal.appealOrder,
    applicationType: complaintAppeal.applicationType,
    appealTitle: complaintAppeal.appealTitle,
    applicationUser: complaintAppeal.applicationUser,
    applicationTime: complaintAppeal.applicationTime,
    // 歌单字段打平
    tracklistId: complaintTrackList.tracklistId,
    // 侵权内容字段打平
    tortMediaType: complaintTrackList.meidaType,
    tortTrackName: complaintTrackList.trackName,
    tortSingerName: complaintTrackList.singerName,
    tortSrcVersion: complaintTrackList.srcVersion,
    tortAlbumName: complaintTrackList.albumName,
    tortAppealPlat: complaintTrackList.appealPlat,
    tortAppealUrl: complaintTrackList.appealUrl,

    // 原曲内容字段打平
    originTrackName: complaintTrackList.originTrackName,
    originSingerName: complaintTrackList.originSingerName,
    originSrcVersion: complaintTrackList.originSrcVersion,
    originAlbumName: complaintTrackList.originAlbumName,
    originWordAuthor: complaintTrackList.originWordAuthor,
    originMusicAuthor: complaintTrackList.originMusicAuthor,
    originRightFile: complaintTrackList.rightFile,
  }
}
